import type { InjectionKey } from 'vue'
import type { AppRoutes } from '@/app/providers/AppRoutes'
import type { AppPages } from './index'

export const EAppProviders = {
    AppRoutes: Symbol() as InjectionKey<typeof AppRoutes>,
    AppPages: Symbol() as InjectionKey<typeof AppPages>
}